import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex flex-col mb-3" }
const _hoisted_2 = { class: "text-sm flex flex-col whitespace-normal" }
const _hoisted_3 = { class: "flex flex-col mb-3" }
const _hoisted_4 = { class: "flex flex-col mb-3" }
const _hoisted_5 = { class: "flex flex-col mb-3" }
const _hoisted_6 = { class: "text-sm flex flex-col whitespace-normal" }
const _hoisted_7 = { class: "flex justify-end" }
const _hoisted_8 = {
  ref: "empty",
  class: "h-0 w-0 outline-none"
}
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = {
  class: "flex sticky bg-next-gray-md border border-next-light-gray z-10",
  style: {"top":"calc(var(--top-navigation-height))"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Star = _resolveComponent("Star")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Modal, {
        visible: _ctx.visible,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
        backdrop: true
      }, {
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Field, { field_name: "Sottoprogetto" }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  ref: "select",
                  onKeydown: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.$refs.select.deactivate()), ["esc"])),
                  "internal-search": false,
                  "close-on-select": true,
                  "clear-on-select": true,
                  class: "next-vue-multiselect-single",
                  placeholder: "Sottoprogetto",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  label: "cod_nodo",
                  options: _ctx.sottoprogettoAutocomplete.options,
                  onSearchChange: _ctx.sottoprogettoAutocomplete.search,
                  modelValue: _ctx.sottoprogettoAutocomplete.selection,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sottoprogettoAutocomplete.selection) = $event))
                }, {
                  option: _withCtx(({option}) => [
                    _createElementVNode("span", _hoisted_2, [
                      _createElementVNode("span", null, "Cod: " + _toDisplayString(option.cod_nodo), 1),
                      _createElementVNode("span", null, "BU: " + _toDisplayString(option.bu_label), 1),
                      _createElementVNode("span", null, "Titolo: " + _toDisplayString(option.titolo), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["options", "onSearchChange", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Field, { field_name: "Tempo" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.time) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.time]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Field, { field_name: "Descrizione" }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("textarea", {
                  class: "border mb-3 border-next-dark-gray",
                  rows: "3",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.note) = $event))
                }, "                        ", 512), [
                  [_vModelText, _ctx.note]
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Field, { field_name: "Attività" }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  options: _ctx.attivitaTimesheetAutocomplete.options,
                  modelValue: _ctx.attivitaTimesheetAutocomplete.selection,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.attivitaTimesheetAutocomplete.selection) = $event)),
                  loading: _ctx.attivitaTimesheetAutocomplete.isLoading,
                  onSearchChange: _ctx.attivitaTimesheetAutocomplete.search,
                  class: "mb-3 next-vue-multiselect-single text-sm",
                  "internal-search": false,
                  "close-on-select": true,
                  "clear-on-select": false,
                  label: "descrizione",
                  "track-by": "id",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona"
                }, {
                  option: _withCtx(({option}) => [
                    _createElementVNode("span", _hoisted_6, [
                      _createElementVNode("span", null, _toDisplayString(option.descrizione), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["options", "modelValue", "loading", "onSearchChange"])
              ]),
              _: 1
            })
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_NextButton, {
              onClick: _ctx.close,
              variant: "outline-secondary",
              class: "w-44 py-1 px-2 mr-2"
            }, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("Chiudi ")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_NextButton, {
              onClick: _ctx.addTimesheet,
              variant: "outline-primary",
              class: "w-44 py-1 px-2"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Salva ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])),
    _createElementVNode("input", _hoisted_8, null, 512),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("ul", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.WeekDays, (d, i) => {
          return (_openBlock(), _createElementBlock("li", {
            class: _normalizeClass(["flex-grow flex flex-col border w-20 text-center cursor-pointer whitespace-nowrap", {'bg-next-orange text-white font-bold': _ctx.isCurrentSelected(d)}]),
            onClick: ($event: any) => (_ctx.$emit('update:date', d.format('YYYY-MM-DD'))),
            key: i
          }, [
            _createElementVNode("span", null, _toDisplayString(d.format('ddd')), 1),
            _createElementVNode("span", null, _toDisplayString(d.format('D')), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.timeToFormat(_ctx.TotaleGiorno(i))) + " ", 1)
          ], 10, _hoisted_11))
        }), 128))
      ]),
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: "text-center p-2 border mt-2",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openModal()))
        }, "+ Aggiungi attività"),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.DailyTimesheet, (d, i) => {
          return (_openBlock(), _createElementBlock("li", {
            key: i,
            onClick: ($event: any) => (_ctx.openModal(d)),
            class: "relative text-center p-2 border mt-2 flex flex-col odd:bg-white even:bg-next-gray-md"
          }, [
            _createVNode(_component_Star, {
              class: "text-xl text-yellow-500 absolute left-3 top-3",
              starred: d.starredByUser,
              onClick: _withModifiers(($event: any) => (_ctx.handleStar(d, _ctx.isAttivita(d))), ["prevent","stop"])
            }, null, 8, ["starred", "onClick"]),
            _createElementVNode("span", null, "Codice nodo: " + _toDisplayString(_ctx.getSottoprogetto(d.sottoprogetto_id)?.titolo), 1),
            _createElementVNode("span", null, "Cliente: " + _toDisplayString(_ctx.getSottoprogetto(d.sottoprogetto_id)?.committente_denominazione), 1),
            _createElementVNode("span", null, [
              _cache[9] || (_cache[9] = _createTextVNode("Sottoprogetto: ")),
              _createElementVNode("b", null, _toDisplayString(_ctx.getSottoprogetto(d.sottoprogetto_id)?.cod_nodo), 1)
            ]),
            _createElementVNode("span", null, [
              _cache[10] || (_cache[10] = _createTextVNode("Tempo: ")),
              _createElementVNode("b", null, _toDisplayString(d?.format), 1)
            ]),
            _createElementVNode("span", null, "Note: " + _toDisplayString(d?.note), 1),
            _createElementVNode("span", null, "Attività: " + _toDisplayString(d?.attivita_timesheet?.descrizione), 1)
          ], 8, _hoisted_12))
        }), 128))
      ])
    ])
  ]))
}